import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LoadingSpinner } from '@/components/LoadingSpinner';
import PageContainer from '@/components/layout/PageContainer';
import { ScrollablePageWrapper } from '@/components/layout/ScrollablePageWrapper';
import SettingsNavbar from './SettingsNavbar';

// Import page components
import { SubscriptionSettings } from './SubscriptionSettings';
import AccountPage from './AccountPage';
import StatisticsPage from './StatisticsPage';

// Create suspense wrapped components to ensure smooth loading experience
const SuspenseSubscription = () => (
  <Suspense fallback={<div className="w-full py-8 flex justify-center"><LoadingSpinner className="w-8 h-8 text-jdblue" /></div>}>
    <SubscriptionSettings />
  </Suspense>
);

const SuspenseAccount = () => (
  <Suspense fallback={<div className="w-full py-8 flex justify-center"><LoadingSpinner className="w-8 h-8 text-jdblue" /></div>}>
    <AccountPage />
  </Suspense>
);

const SuspenseStatistics = () => (
  <Suspense fallback={<div className="w-full py-8 flex justify-center"><LoadingSpinner className="w-8 h-8 text-jdblue" /></div>}>
    <StatisticsPage />
  </Suspense>
);

export function SettingsPage() {
  return (
    <ScrollablePageWrapper navbar={<SettingsNavbar />}>
      <PageContainer disablePadding={false} className="pt-6 pb-6 md:pb-12 mx-auto px-4" maxWidth="6xl" noOverflow={true}>
        <Routes>
          {/* Settings routes */}
          <Route path="/" element={<SuspenseSubscription />} />
          <Route path="account" element={<SuspenseAccount />} />
          <Route path="appearance" element={<Navigate to="/settings/account" replace />} />
          <Route path="statistics" element={<SuspenseStatistics />} />

          {/* Fallback route */}
          <Route path="*" element={<Navigate to="/settings" replace />} />
        </Routes>
      </PageContainer>
    </ScrollablePageWrapper>
  );
} 